(function (factory) {
  const estimator = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = estimator;
  if (typeof document !== 'undefined') estimator.start();
})(function () {
  'use strict';
const {STANDARD_END_AREA,WIDE_END_AREA,FOLIAGE_END_AREA,SIDE_AREA_RATE,FABRICS,LENGTHS,LAYERS,RIDGELINES,SUSPENSIONS,DELTAS,SACKS}=window.SLDEstimatorData.products["streamliner"];
const CONTROLS=window.SLDEstimatorData.productControls.streamliner;

  const FIELD_LABELS = Object.freeze({
    'Fabric/Color * (required)': 'Fabric/Color',
    'Length * (required)': 'Length',
    'Layers * (required)': 'Layers',
    'Adjustable Ridgeline * (required)': 'Adjustable Ridgeline',
    'Suspension * (required)': 'Suspension Type',
    'Knee & Shoulder Tie Outs * (required)': 'Knee & Shoulder Tie Outs',
    'Continuous Loops * (required)': 'Continuous Loops',
    'Peak Shelf * (required)': 'Peak Shelf',
    'Stuff Sack Options * (required)': 'Stuff Sack Options',
    'Under Quilt Hooks * (required)': 'Under Quilt Hooks',
    'Zippered Shoulder Pouch * (required)': 'Zippered Shoulder Pouch'
  });

  
  
  
  

  

  
  
  
  
  
  
  const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
  function selections(scope) { const selected = Object.create(null); for (const element of scope.querySelectorAll('select')) { const domLabel = clean(element.labels && element.labels[0] && element.labels[0].textContent); if (!own(FIELD_LABELS, domLabel)) continue; selected[FIELD_LABELS[domLabel]] = clean(element.value); } return selected; }
  function cutLayer(length, fabric) { const rawLength = length * 12 + 8; const rawRectangle = rawLength * fabric.width / 1296 * fabric.density; const sideDeduction = rawLength * SIDE_AREA_RATE / 1296 * fabric.density; const endDeduction = fabric.endArea / 1296 * fabric.density; return rawRectangle - sideDeduction - endDeduction; }
  function estimate(choice) {
    if (choice['Fabric/Color'] === 'Custom (Please Contact Me First)') return { manual: true };
    const fabric = FABRICS[choice['Fabric/Color']], length = LENGTHS[choice.Length], layers = LAYERS[choice.Layers], ridgeline = RIDGELINES[choice['Adjustable Ridgeline']], suspension = SUSPENSIONS[choice['Suspension Type']], sackPocket = SACKS[choice['Stuff Sack Options']];
    if (!fabric || !length || !layers || !ridgeline || !suspension || sackPocket === undefined) return null;
    let hammock = cutLayer(length, fabric) * layers + ridgeline[length];
    for (const field of Object.keys(DELTAS)) { const values = DELTAS[field]; if (!own(values, choice[field])) return null; hammock += values[choice[field]]; }
    const withSuspension = hammock + suspension.weight; const mainSack = (fabric.width >= 67 ? CONTROLS.mainSacks.wide : CONTROLS.mainSacks.standard) + sackPocket; const packed = withSuspension + mainSack + suspension.sack;
    return { hammock, withSuspension, packed, mainSack };
  }
  function start() {
    const root = document.querySelector('[data-sld-streamliner-estimator]'); if (!root) return; const scope = root.closest('product-info') || document;
    function calculate() { const result = estimate(selections(scope)); const results = root.querySelector('[data-sld-estimator-results]'); const message = root.querySelector('[data-sld-estimator-message]'); if (!result || result.manual) { if (results) results.hidden = true; if (message) message.textContent = result && result.manual ? 'Custom fabrics require a manual weight estimate. Please contact me before ordering.' : 'Select the hammock length and fabric above to see the estimated weight.'; return; } const set = (selector, value) => { const element = root.querySelector(selector); if (element) element.textContent = value.toFixed(1) + ' oz'; }; set('[data-sld-weight-hammock]', result.hammock); set('[data-sld-weight-suspension]', result.withSuspension); set('[data-sld-weight-packed]', result.packed); if (results) results.hidden = false; if (message) message.textContent = ''; }
    let timer; const queue = () => { clearTimeout(timer); timer = setTimeout(calculate, 75); }; document.addEventListener('change', queue, true); document.addEventListener('input', queue, true); document.addEventListener('click', queue, true); new MutationObserver(queue).observe(scope, { subtree: true, attributes: true, attributeFilter: ['value', 'checked', 'selected', 'class', 'aria-checked'], childList: true }); calculate();
  }
  return { cutLayer, estimate, selections, start };
});
